import _taggedTemplateLiteral from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        @media (min-width: ", ") {\n          max-width: ", ";\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          max-width: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    margin: 0 auto;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';

function rem(px) {
  return "".concat(px / 16, "rem");
}

export function containerBaseStyles() {
  return css(_templateObject());
}
export function containerWidthStyles(props) {
  var theme = props.theme;
  var container = theme.sanity.container;
  return css(_templateObject2(), props.width.map(function (spaceIndex, mqIndex) {
    if (mqIndex === 0) return css(_templateObject3(), rem(container[spaceIndex]));
    return css(_templateObject4(), rem(theme.sanity.media[mqIndex - 1]), rem(container[spaceIndex]));
  }));
}